var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReadyfordispatch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.627 19.2744C21.6267 21.1849 20.0866 22.7334 18.1865 22.7334H6.39062C4.49057 22.7334 2.95041 21.1849 2.9502 19.2744V9.7998H21.627V19.2744ZM9.33984 11.8604C9.06839 11.8604 8.84766 12.0825 8.84766 12.3555C8.84789 12.6282 9.06853 12.8496 9.33984 12.8496H15.2373C15.5086 12.8496 15.7293 12.6282 15.7295 12.3555C15.7295 12.0825 15.5088 11.8604 15.2373 11.8604H9.33984ZM21.1357 1.97656C21.95 1.97656 22.6102 2.64025 22.6104 3.45898V7.41309C22.6103 8.05856 22.1996 8.60801 21.627 8.81152H2.9502C2.37754 8.60801 1.96687 8.05856 1.9668 7.41309V3.45898C1.96691 2.64025 2.62711 1.97656 3.44141 1.97656H21.1357Z",
    fill: "#E86A0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadyfordispatch);
export default __webpack_public_path__ + "static/media/readyfordispatch.2e7feded9adbd43509f639d5821f0aa5.svg";
export { ForwardRef as ReactComponent };